import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { ComponentProps, ReactElement } from "react";
// eslint-disable-next-line drops/no-direct-spor-import
import { Box, Expandable } from "@vygruppen/spor-react";
import { StyleTarget } from "shared/components/StyleTarget";
import { FCWC } from "shared/utils/FCWC";
import { css } from "styled-components";

type ExpandableProps = ComponentProps<typeof Expandable>;

type DropsExpandableProps = Omit<ExpandableProps, "title"> & {
  title: string | ReactElement;
  collapsible: boolean; // This is here since `collapsible` should absolutely not be an optional prop. Atleast then it should be collapsible by default.
  backgroundColor?: string;
  borderRadius?: string; // For the button. Make another argument if you need to control the body specifically
};

export const InternalDropsExpandable: FCWC<DropsExpandableProps> = ({
  title,
  backgroundColor,
  borderRadius = "12px",
  children,
  ...props
}) => (
  <StyleTarget
    /**
     * Splits the backgroundColor to the two smaller containers.
     * Letting us put DashedLine between them.
     */
    $style={css`
      .spor-accordion__item {
        outline: none;
        /* For DashedLine */
        position: relative;
      }
      .spor-accordion__itemTrigger {
        outline: 0px;
        border-radius: ${borderRadius};
        background: ${({ theme }) =>
          backgroundColor ?? theme.colorBackgroundSecondary};
        &:hover {
          filter: ${({ theme }) => theme.filterHover};
        }
      }
      .spor-accordion__itemBody {
        border-radius: 12px;
        background: ${({ theme }) =>
          backgroundColor ?? theme.colorBackgroundSecondary};

        padding: 0px;
        margin-top: 3px;
      }
    `}
    $target="&&&"
  >
    <Expandable title={title} {...props}>
      <DashedLine
        variant="secondary"
        mt="-3px"
        mb="3px"
        insetX="0"
        position="absolute"
      />
      <Box p="12px">{children}</Box>
    </Expandable>
  </StyleTarget>
);
